module.exports = __webpack_public_path__ + "images/1ceec227f3da584dcbfcce391d2d917c.png";